import { Avatar, Tooltip } from 'antd'
import { UserAddOutlined } from "@ant-design/icons"
import { useSchedule } from '../ScheduleContext'
import { getInitials } from '../scheduleModel'

type Props = {
  crewMemberIds?: string | null
  crewLeadId?: number | null
}

const OnDemandRouteAvatarGroup = ({ crewMemberIds, crewLeadId }: Props) => {
  const { crew } = useSchedule()

  const crewIds = crewMemberIds ? crewMemberIds.split(',').map(id => parseInt(id)).filter(id => !isNaN(id)) : []

  return (
    <Avatar.Group
      size="small"
      max={{
        count: 1,
        style: {
          opacity: 0.5,
          backgroundColor: '#faad14'
        }
      }}
    >
      {!crewLeadId && (
        <Tooltip title="No Crew Lead">
          <Avatar style={{ backgroundColor: '#FFF1F0', border: '1px dashed #820014', color: '#820014' }} icon={<UserAddOutlined />} />
        </Tooltip>
      )}
      {crewIds.sort((a, b) => {
        if (a === crewLeadId) { return -1 }
        if (b === crewLeadId) { return 1 }
        return 0
      }).map(id => {
        const member = crew?.find(c => c.id === id)
        return (
          <Tooltip key={id} title={member?.name || 'Unknown'}>
            <Avatar
              src={member?.hasStockAvatar ? undefined : member?.avatar}
              style={member?.hasStockAvatar || !member?.avatar ? { backgroundColor: member?.color || '#d9d9d9', color: '#fff' } : undefined}
            >
              {member?.name ? getInitials(member.name) : '?'}
            </Avatar>
          </Tooltip>
        )
      })}
    </Avatar.Group>
  )
}

export default OnDemandRouteAvatarGroup